
import { Search, SquarePlus, Settings, Ship,  CalendarClock, UserX} from "lucide-react"
import { useContext, useEffect, useState, } from "react";
import { Link } from "react-router-dom"

import SearchDialog from "./ui/SearchDialog";
import { UserContext } from "@/App";

import LoginDialog from "./LoginDialog";
import { Avatar } from "@radix-ui/react-avatar";
import { AvatarFallback, AvatarImage } from "./ui/avatar";
import ProfileSettings from "./ProfileSettings";
import { Button } from "./ui/button";



export default function Navbar () {
    const [activePage, setActivePage] = useState<"edit"|"consumelater"|"profile">();
    const activePageSubStrings = ["edit", "consumelater", "profile"];


    const {user, setUser} = useContext(UserContext);

    const username = user.username || localStorage.getItem("username");
    const avatar = user.avatar || localStorage.getItem("avatar");

    const profileRoute = username ? `/profile/${username}/` : "/";

    const activePageStyles = "rounded-r-none border-r-2 border-white"

    useEffect(()=>{
        activePageSubStrings.some((route) => {
            if (location.pathname.includes(route)) {
                setActivePage(route as "edit"|"consumelater"|"profile");
            }
        }
    )
    },[window.location.pathname])

    return(
        <>
            <nav className="flex flex-col h-screen bg-black/30 backdrop-blur-md ">
            
                <div className="flex justify-center items-center pt-4">
                    <Link to={"/"}><Ship className="w-7 h-7 hover:cursor-pointer text-neutral-300" /></Link>
                </div>
                <div className="flex flex-col justify-center h-full w-full">
                    <div className="w-full pb-10 flex flex-col justify-center gap-6 text-neutral-200">
                        
                        <SearchDialog>
                            <Button size={"icon"} variant={"ghost"} className={`w-full ease-in-out duration-200 h-10 bg-transparent hover:cursor-pointer hover:bg-transparent hover:text-white active:text-neutral-500`}>
                                <Search className="flex !w-6 !h-6 hover:cursor-pointer"/>
                            </Button>
                        </SearchDialog>
                        
                         <Button size={"icon"} variant={"ghost"} className={`w-full ease-in-out duration-200 h-10 bg-transparent hover:cursor-pointer hover:bg-transparent hover:text-white active:text-neutral-500 ${activePage == "edit" ? activePageStyles : ""}`}>
                            <Link to="/list/edit/">
                                <SquarePlus className="flex !w-6 !h-6 hover:cursor-pointer"/>
                            </Link>
                         </Button>
                        

                        {
                            username ?
                               <Button size={"icon"} variant={"ghost"} className={`w-full ease-in-out duration-200 h-10 bg-transparent hover:cursor-pointer hover:bg-transparent hover:text-white active:text-neutral-500 ${activePage == "consumelater" ? activePageStyles : ""}`}>
                                    <Link to={`/consumelater/${username}/`}>
                                        <CalendarClock className="!w-6 !h-6 hover:cursor-pointer"/>  
                                    </Link>
                                </Button>
                            :
                                <LoginDialog>
                                    <Button size={"icon"} variant={"ghost"} className={`w-full ease-in-out duration-200 h-10 bg-transparent hover:cursor-pointer hover:bg-transparent hover:text-white active:text-neutral-500 `}>
                                        <CalendarClock className="!w-6 !h-6 hover:cursor-pointer"/>
                                    </Button>
                                </LoginDialog>
                        }
                    </div>

                    <div className="flex flex-col gap-6 justify-center items-center text-neutral-200 border-t-2 border-primary pt-10">
                        {username ? 
                        <Button size={"icon"} variant={"ghost"} className={`w-full ease-in-out duration-200 h-10 bg-transparent hover:cursor-pointer hover:bg-transparent hover:text-white active:text-neutral-500 ${activePage == "profile" ? activePageStyles : ""}` }>
                            <Link to={profileRoute}>
                                <Avatar className="text-black"> 
                                    <AvatarImage className="rounded-full border-2 border-white w-10 h-10" src={avatar ?? ""} /> 
                                    <AvatarFallback className="rounded-full border-2 text-blacke border-white w-10 h-10">:)</AvatarFallback>
                                </Avatar>
                            
                            </Link> 
                        </Button>
                            :
                            <LoginDialog>
                                <Button size={"icon"} variant={"ghost"} className={`w-full ease-in-out duration-200 h-10 bg-transparent hover:cursor-pointer hover:bg-transparent hover:text-white active:text-neutral-500` }>
                                    <UserX className="!w-6 !h-6 hover:cursor-pointer"/>
                                </Button>
                            </LoginDialog> 
                        }
                        {username ?
                            
                            <ProfileSettings>
                                <Settings className="w-6 h-6 hover:cursor-pointer"/>
                            </ProfileSettings>
                            :
                            <LoginDialog>
                                <Settings className="w-6 h-6 hover:cursor-pointer"/>
                            </LoginDialog>
                        }
                        
                        
                    </div>
                </div>
                
            </nav>
        </>
        
    )
}